import { useLocale } from '@/contexts/localeContext';
import { TranslationKeys } from '@/contexts/TranslationKeys';
import { FC } from 'react';

interface BackButtonProps {
    onClick: (event: any) => void;
    className?: string;
}

export const BackButton: FC<BackButtonProps> = ({ onClick, className = "secondary secondary-inverse py-1 px-5" }) => {
    const { translate } = useLocale();
    return <button className={className} type="button" onClick={onClick}>
        {translate.byKey(TranslationKeys.back)}
    </button>
};